import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { TooltipTextProvider } from '@elliemae/ds-basic/TruncatedTooltipText';
import { Position, positions } from '@elliemae/ds-popper/positions';
import { Interaction, interactions } from '@elliemae/ds-popper/interaction';
import DropdownMenuWrapper from './DropdownMenuWrapper.js';
import './DropdownMenuProvider.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-utilities/utils';
import './DropdownMenuContext.js';
import './DropdownMenuRenderer.js';
import '@babel/runtime/helpers/esm/extends';
import '@elliemae/ds-utilities/getComponentFromProps';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-basic/Menu';
import '@elliemae/ds-classnames';
import './decoratedMenuItemFactory.js';
import './MenuItemClickableHOC.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import './MenuItemGroupSelectionHOC.js';
import './DropdownMenuLoadingIndicator.js';
import 'styled-components';
import '@elliemae/ds-basic/CircularProgressIndicator';

/* eslint-disable max-lines */

var noop = function noop() {
  return null;
};

var DSDropdownMenu = function DSDropdownMenu(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$contentStyle = _ref.contentStyle,
      contentStyle = _ref$contentStyle === void 0 ? null : _ref$contentStyle,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onSelectMenuItem = _ref.onSelectMenuItem,
      onSelectMenuItem = _ref$onSelectMenuItem === void 0 ? noop : _ref$onSelectMenuItem,
      _ref$onOpenMenu = _ref.onOpenMenu,
      onOpenMenu = _ref$onOpenMenu === void 0 ? noop : _ref$onOpenMenu,
      _ref$onClickOutsideMe = _ref.onClickOutsideMenu,
      onClickOutsideMenu = _ref$onClickOutsideMe === void 0 ? noop : _ref$onClickOutsideMe,
      _ref$preventOverflow = _ref.preventOverflow,
      preventOverflow = _ref$preventOverflow === void 0 ? 'viewport' : _ref$preventOverflow,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? Position.BOTTOM_START : _ref$placement,
      _ref$interactionType = _ref.interactionType,
      interactionType = _ref$interactionType === void 0 ? Interaction.CLICK : _ref$interactionType,
      _ref$triggerComponent = _ref.triggerComponent,
      triggerComponent = _ref$triggerComponent === void 0 ? noop : _ref$triggerComponent,
      _ref$customMenu = _ref.customMenu,
      customMenu = _ref$customMenu === void 0 ? null : _ref$customMenu,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? undefined : _ref$isOpen,
      _ref$selection = _ref.selection,
      selection = _ref$selection === void 0 ? {} : _ref$selection,
      _ref$menuProps = _ref.menuProps,
      menuProps = _ref$menuProps === void 0 ? {} : _ref$menuProps,
      _ref$referenceNode = _ref.referenceNode,
      referenceNode = _ref$referenceNode === void 0 ? undefined : _ref$referenceNode,
      _ref$focusOnOpen = _ref.focusOnOpen,
      focusOnOpen = _ref$focusOnOpen === void 0 ? false : _ref$focusOnOpen,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
      _ref$itemsRenderer = _ref.itemsRenderer,
      itemsRenderer = _ref$itemsRenderer === void 0 ? undefined : _ref$itemsRenderer,
      _ref$responsiveHeight = _ref.responsiveHeight,
      responsiveHeight = _ref$responsiveHeight === void 0 ? false : _ref$responsiveHeight,
      _ref$singleGroupSelec = _ref.singleGroupSelection,
      singleGroupSelection = _ref$singleGroupSelec === void 0 ? false : _ref$singleGroupSelec,
      _ref$onSelectChange = _ref.onSelectChange,
      onSelectChange = _ref$onSelectChange === void 0 ? noop : _ref$onSelectChange,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? undefined : _ref$minWidth,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? undefined : _ref$maxWidth,
      zIndex = _ref.zIndex,
      type = _ref.type,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      hideIfNotVisible = _ref.hideIfNotVisible;
  return /*#__PURE__*/React.createElement(TooltipTextProvider, null, /*#__PURE__*/React.createElement(DropdownMenuWrapper, {
    hideIfNotVisible: hideIfNotVisible,
    className: className,
    containerProps: containerProps,
    contentStyle: contentStyle,
    customMenu: customMenu,
    focusOnOpen: focusOnOpen,
    interactionType: interactionType,
    isOpen: isOpen,
    itemsRenderer: itemsRenderer,
    maxWidth: maxWidth,
    menuProps: menuProps,
    minWidth: minWidth,
    onClickOutsideMenu: onClickOutsideMenu,
    onClose: onClose,
    onOpenMenu: onOpenMenu,
    onSelectChange: onSelectChange,
    onSelectMenuItem: onSelectMenuItem,
    options: options,
    placement: placement,
    preventOverflow: preventOverflow,
    referenceNode: referenceNode,
    responsiveHeight: responsiveHeight,
    selection: selection,
    singleGroupSelection: singleGroupSelection,
    triggerComponent: triggerComponent,
    type: type,
    zIndex: zIndex,
    loading: loading
  }));
};

var dropdownMenuProps = {
  hideIfNotVisible: PropTypes.bool.description('Hide menu component if trigger component is not visible/scrolled away'),
  containerProps: PropTypes.shape({}).description('Set of Properties attached to the main container'),
  contentStyle: PropTypes.shape({}).description('Object style passed to the menu'),
  options: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string
  })).description('Options items for the dropdown menu. Check menu item types'),
  onSelectMenuItem: PropTypes.func.description('Handler when user clicks on a menu item'),
  onOpenMenu: PropTypes.func.description('Handler when the menu shows up'),

  /**  Handler when user clicks outside the menu */
  onClickOutsideMenu: PropTypes.func.description('Handler when user clicks outside the menu'),

  /** Prevent to move the menu outside of the container defined when interacting with the page  */
  preventOverflow: PropTypes.oneOf(['viewport', 'scrollParent', 'window']).description('Prevent to move the menu outside of the container defined when interacting with the page'),

  /** Menu placement */
  placement: PropTypes.oneOf(positions).description('Menu placement'),

  /** How to open the menu with click, hover */
  interactionType: PropTypes.oneOf(interactions).description('How to open the menu with click, hover'),

  /** The component that is going to open / close the menu */
  triggerComponent: PropTypes.element.description('The component that is going to open / close the menu'),

  /** Custom menu component */
  customMenu: PropTypes.element.description('Custom menu component'),

  /** Whether the menu is open or not */
  isOpen: PropTypes.bool.description('Whether the menu is open or not'),

  /** Selection state. Ex: { [itemId]: '{bool}', [idMultiSelectionItem]: '{string}' } */
  selection: PropTypes.shape({}).description('Selection state. Ex: { [itemId]: {bool}, [idMultiSelectionItem]: {string} }'),

  /** Props object passed to the menu component */
  menuProps: PropTypes.shape({}).description('Props object passed to the menu component'),

  /** Customize the items render */
  itemsRenderer: PropTypes.func.description('Customize the items render'),

  /** Customize menu format. Can be undefined or 'phone' */
  type: PropTypes.string.description('Customize menu format. Can be undefined or "phone"'),

  /** Customize menu minWidth. Can be undefined or 'number' */
  minWidth: PropTypes.number.description('Customize menu minWidth. Can be undefined or "number"'),

  /** Customize menu maxWidth. Can be undefined or 'number' */
  maxWidth: PropTypes.number.description('Customize menu maxWidth. Can be undefined or "number"'),

  /** Make the menu responsive, it uses a margin of 120 px */
  responsiveHeight: PropTypes.bool.description('Make the menu responsive, it uses a margin of 120 px'),

  /** Customize menu zIndex. Can be undefined or 'number' */
  zIndex: PropTypes.number.description('Customize menu zIndex. Can be undefined or "number"'),
  className: PropTypes.string.description('html class attribute'),
  focusOnOpen: PropTypes.bool.description('focus element on open or not').defaultValue(true),
  loading: PropTypes.bool.description('is loading content or not').defaultValue(false),
  referenceNode: PropTypes.any.description('reference node'),
  onClose: PropTypes.func.description('function called on close mene'),
  onSelectChange: PropTypes.func.description('function called when selection changes'),
  singleGroupSelection: PropTypes.bool.description('select items in same group or not')
};
DSDropdownMenu.propTypes = dropdownMenuProps;
var DropdownMenuWithSchema = describe(DSDropdownMenu);
DropdownMenuWithSchema.propTypes = dropdownMenuProps;

export default DSDropdownMenu;
export { DropdownMenuWithSchema };
//# sourceMappingURL=DSDropdownMenu.js.map
